import { cssRule } from 'typestyle';

cssRule('.tb-server-settings-icon-', {
    display: 'inline-block',
    width: '10px',
    height: '10px',
});

cssRule('.tb-server-settings-icon-pending', {
    display: 'inline-block',
    width: '10px',
    height: '10px',
    background: 'url(img/busy.gif?1_0_9606_yabs0uv7t1h) no-repeat',
});

cssRule('.tb-passwords-first-row > td', {
    paddingTop: '26px',
});

cssRule('.tb-passwords-last-row > td', {
    paddingBottom: '26px',
});

cssRule('.tb-frequency-label', {
    verticalAlign: 'top',
    paddingRight: '35px',
});

cssRule('.tb-server-settings-sign-in-note-count', {
    fontSize: '9px',
    display: 'block',
});

